import {
  Alert,
  Button,
  Flex,
  Skeleton,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { useImplementationsQuery } from './implementations.gql.generated';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { Icon } from '~/packages/common-frontend/components/icons';

// Exports
export const ImplementationsTable = () => {
  const borderColor = useColorModeValue('gray.100', 'gray.900');

  const { user } = useUserAuthOrThrow();

  const query = useImplementationsQuery({
    variables: { organizationId: user.organizationId },
  });
  if (query.error) throw query.error;
  if (!query.data) return <Skeleton h="600px" />;

  const implementations = query.data.organization.implementations;

  return (
    <Flex width="100%" overflowX="auto">
      <Table borderWidth="1px" borderColor={borderColor}>
        <Thead>
          <Tr>
            <Th>Name</Th>
          </Tr>
        </Thead>
        <Tbody>
          {implementations.map((implementation) => (
            <Tr key={implementation.id}>
              <Td padding="0.25rem">
                <Button
                  as={RouterLink}
                  to={
                    implementation.creditFacilities.length === 1
                      ? `${implementation.id}/facilities/${implementation.creditFacilities[0].id}`
                      : `${implementation.id}`
                  }
                  variant="v2-ghost"
                  colorScheme="gray"
                  fontWeight={400}
                  width="100%"
                  justifyContent="space-between"
                  gap="1rem"
                >
                  {implementation.name}
                  <Flex as="span" gap="0.5rem">
                    <Text as="span" fontWeight={400} fontSize="0.875rem">
                      View Details
                    </Text>
                    <Icon icon="chevron-right" />
                  </Flex>
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
      {implementations.length === 0 && (
        <Alert>No implementations are defined.</Alert>
      )}
    </Flex>
  );
};
